import { render } from "./Vehicle.vue?vue&type=template&id=4d2c6106&ts=true"
import script from "./Vehicle.vue?vue&type=script&lang=ts"
export * from "./Vehicle.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./Vehicle.vue?vue&type=style&index=0&id=4d2c6106&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__